import {Directive, ElementRef, Input, Component, HostListener} from "@angular/core";

@Directive({
  selector: '[IntegerNumber]'
})

export class IntegerNumberDirective {

    @Input('allowNegative') 
    allowNegative: boolean = false;

    @Input('fieldName') 
    fieldName: string = "";

     private regexPositiveStr = '^[0-9]*$';
     private regexStr = '^[0-9\-]+$';
    private exprDotAllowed = '^[0-9\-]*\.?[0-9]*$';

    // Allow key codes for special events. Reflect :
     // Backspace, tab, end, home
    private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home', '-'  ];
    constructor(private el: ElementRef) { }
  
    @HostListener('keydown', ['$event']) 
    onKeyDown(e: KeyboardEvent) {
        console.log(this.fieldName);
        // Allow Backspace, tab, end, and home keys 
        if (this.specialKeys.indexOf(e.key) !== -1) {
            return;
        }
        
        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        let current: string = this.el.nativeElement.value;
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        let next: string = current.concat(e.key);
        let regexString = this.regexStr //this.allowNegative ? this.regexStr : this.regexPositiveStr;

        let find = this.fieldName.toLowerCase().includes("period");

        if(!find)
        {
            regexString = this.exprDotAllowed;
        }

        if (next && !String(next).match(regexString)) {
            e.preventDefault();
        }
    }
 }
  